
import React, { useState } from 'react';
import Input from '../../../../../Components/Input';
import uploadIcon from '../../../../../Assets/Icons/upload.png'
import InvoiceTaxationController from '../../../../Controllers/AdminScreens/Invoices/Settings/InvoiceTaxationController';
import Loader from '../../../../../Components/Loader';
import LoadingSkeleton from '../../../../../Components/LoadingSkeleton';


const InvoiceTaxationScreen = ({ taxSgst, taxCgst, taxIgst, taxConvFee, loadingSettings, errorSettings, onRefresh }) => {
    const {
        cgst,
        setCgst,
        sgst,
        setSgst,
        igst,
        setIgst,
        conveyanceFee,
        setConveyanceFee,
        handleUpdateTaxation,
        loading,
        error,
        success,
        isEditing,
        setIsEditing,
        cgstError,
        sgstError,
        igstError,
        convFeeError,handleCancel,
        handleInputChange,
    } = InvoiceTaxationController(taxSgst, taxCgst, taxIgst, taxConvFee, errorSettings, onRefresh);

    return (
        <div style={styles.container}>
            <h2 style={{ ...styles.title, ...(isEditing ? { marginBottom: '10px' } : {}) }}>Taxation</h2>
            {["CGST", "SGST", "IGST", "Conveyance Fee"].map((field, index) => {
                const fieldMappings = {
                    "CGST": { key: "cgst", value: cgst, error: cgstError },
                    "SGST": { key: "sgst", value: sgst, error: sgstError },
                    "IGST": { key: "igst", value: igst, error: igstError },
                    "Conveyance Fee": { key: "conveyanceFee", value: conveyanceFee, error: convFeeError }
                };

                const fieldKey = fieldMappings[field].key;
                const fieldValue = fieldMappings[field].value;
                const fieldError = fieldMappings[field].error;

                return (
                    <div key={index} style={{ ...styles.field, ...(isEditing ? { marginBottom: '0px', marginTop: '0px' } : {}) }}>
                        <label style={styles.label}>{field}</label>
                        {isEditing ? (
                            <Input
                                value={fieldValue}
                                onChange={(e) => handleInputChange(fieldKey, e.target.value)}
                                errorMessage={fieldError}
                                inputType='number'
                            />
                        ) : (
                            <span style={styles.value}>{loadingSettings ? (<LoadingSkeleton width="100px" height="15px" />) : (<span>{fieldValue == null ? '--':fieldValue }</span>)}</span>
                        )}
                    </div>
                );
            })}

            <hr className="footer-divider" />
            <div className="button-container" style={{ gap: "10px" }}>
                {isEditing ? (

                    <>
                        <button className="add-client-button" onClick={handleUpdateTaxation}
                            style={{ ...styles.updateButton, paddingLeft: 30, paddingRight: 30, opacity: loading ? 0.5 : 1, cursor: loading ? 'not-allowed' : 'pointer', }} disabled={loading}>
                            <span style={{ paddingRight: loading ? 10 : 0 }}><Loader loading={loading} color={'#FFFFFF'} size='small' /></span>
                            Update</button>
                        <button style={styles.cancelButton} onClick={() => { handleCancel() }}>Cancel</button>
                    </>

                ) : (
                    <button className="add-client-button" onClick={() => setIsEditing(true)}
                        style={{ paddingLeft: 30, paddingRight: 30, opacity: loadingSettings ? 0.5 : 1, cursor: loadingSettings ? 'not-allowed' : 'pointer', }} disabled={loadingSettings}>
                        Edit
                    </button>
                )}
                {error && <div className="list-error-msg" style={{ marginBottom: '3px' }}> {error} </div>}
                {success && <div className="list-success-msg" style={{ marginBottom: '3px' }}>{success} </div>}
            </div>

        </div>
    );

}

const styles = {
    // container: {
    //   width: "600px",
    //   margin: "0 auto",
    //   fontFamily: "Arial, sans-serif",
    // },
    title: {
        color: 'black',
        fontSize: 18,
        fontFamily: 'Roboto',
        fontWeight: '500',
    },
    field: {
        display: "flex",
        alignItems: "center",
        marginBottom: "25px",
        marginTop: "25px",
    },
    label: {
        flex: "0 0 200px", // Ensures all labels are the same width
        color: 'black',
        fontSize: 14,
        fontFamily: 'Roboto',
        fontWeight: '400',
    },
    // input: {
    //   flex: "1",
    //   height: "30px",
    //   padding: "5px 10px",
    //   fontSize: "14px",
    //   border: "1px solid #d1d5db",
    //   borderRadius: "4px",
    // },

    addServiceButton: {
        backgroundColor: "transparent",
        border: "1px #858585 solid",
        borderRadius: "5px",
        padding: "8px 12px",
        color: "#40513B",
        cursor: "pointer",
        fontSize: '12px',
        fontFamily: 'Roboto',
        fontWeight: '400',
        borderRadius: '28px',
        // marginBottom:'16px'
        display: "flex", // Use flexbox for alignment
        alignItems: "center", // Vertically align icon and text
        justifyContent: "center",
    },
    icon: {
        width: "12px",
        height: "12px",
        marginRight: "10px",
    },
    cancelButton: {
        display: "flex",
        alignItems: "center",
        backgroundColor: "white",
        color: "var(--button-bg-color)",
        border: "1px solid var(--button-bg-color)",
        padding: "8px 16px",
        borderRadius: '20px',
        cursor: "pointer",
    }
};

export default InvoiceTaxationScreen